import Vue from 'vue'
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import ElementUI from 'element-ui'
import '../theme/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import '@/styles/index.scss' // global css
import App from './App'
import store from './store'
import router from './router'
import '@/icons' // icon
import '@/permission' // permission control
import Print from 'vue-print-nb'
import Component from '@/components'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
import showPageMixin from '@/mixin/showPageMixin'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import dataV from "@jiaminghi/data-view";
Vue.use(Component)
Vue.use(ElementUI, { size: "small" })
Vue.use(Print)
Vue.mixin(showPageMixin)
Vue.use(VXETable)
Vue.use(dataV)
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
